









































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ReferralEspoedDetailsModel } from "@/types/aznconnect_api";

@Component
export default class ArrivalTimerView extends Vue {
  @Prop({ default: null })
  referral!: ReferralEspoedDetailsModel;

  @Prop({ default: null })
  referralState!: string;

  @Prop({ default: true })
  showTimer!: boolean;

  @Prop({ default: false })
  showHistory!: boolean;

  currentTime: Date = new Date();
  timerInterval: any = null;

  mounted() {
    this.timerInterval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  }

  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  openHistory(): void {
    this.$emit("show-history");
  }

  get lastUpdateDateTime(): string {
    return `${this.referral.MessageDate} ${this.referral.MessageTime}`;
  }

  get showTimeUntilArrival(): boolean {
    return (
      this.referral &&
      !!this.referral.AmbulanceId &&
      !!this.referral.EtaDate &&
      !!this.referral.EtaTime
    );
  }

  private get etaDateTime(): Date | null {
    if (!this.referral.EtaDate || !this.referral.EtaTime) return null;
    const [day, month, year] = this.referral.EtaDate.split("-");
    return new Date(`${year}-${month}-${day}T${this.referral.EtaTime}`);
  }

  get timeUntilArrivalText(): string {
    if (!this.showTimeUntilArrival) return "--:--";

    const eta = this.etaDateTime;
    if (!eta) return "--:--";
    const diff = eta.getTime() - this.currentTime.getTime();

    if (diff <= 0) {
      return "Aangekomen";
    }

    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);

    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }

  get timeUntilArrivalColor(): string {
    if (!this.showTimeUntilArrival) return "#757575";

    const eta = this.etaDateTime;
    if (!eta) return "#757575";
    const diff = eta.getTime() - this.currentTime.getTime();
    const minutes = Math.floor(diff / 60000);

    if (diff <= 0) {
      return "#4CAF50"; // Green - arrived
    } else if (minutes <= 2) {
      return "#F44336"; // Red - very urgent (0-2 minutes)
    } else if (minutes <= 5) {
      return "#FF9800"; // Orange - urgent (3-5 minutes)
    } else {
      return "#2196F3"; // Blue - normal (>5 minutes)
    }
  }

  get timeProgressPercentage(): number {
    if (!this.showTimeUntilArrival) return 0;

    const eta = this.etaDateTime;
    if (!eta) return 0;
    const now = this.currentTime.getTime();
    const etaTime = eta.getTime();

    // Use a fixed 30-minute countdown window:
    // 0% when 30+ minutes remain, 100% when ETA is reached/passed.
    const windowMs = 30 * 60 * 1000;
    const remaining = etaTime - now;

    if (remaining <= 0) return 100;

    return Math.max(0, ((windowMs - remaining) / windowMs) * 100);
  }
}
